import { Component, OnInit } from '@angular/core';
import axios from 'axios';

@Component({
  selector: 'app-checkqueueonline',
  templateUrl: './checkqueueonline.component.html',
  styleUrls: ['./checkqueueonline.component.css']
})
export class CheckqueueonlineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.LoadQueSetup();
  }

  // โหลดสถานะคิวตอนนี้
  getqueue:any;
  LoadQueSetup(){
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/select_Setup")
    .then(res => {
    this.getqueue = res.data.recordset;
    }).catch(err => { throw err })
  }

  // สลับคิวสถานะ
  lastid=0;
  SwithQueu(id:any){
    this.lastid = this.lastid + parseInt(id);
    let open  ="https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/update_Setup?chk_looplost='N'"; // เปิด
    let close = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/update_Setup?chk_looplost='Y'"; // ปิด
    let url='';
    if (id % 2 == 0){
      url = close;
    }
    else {
      url = open;
    }
    console.log(url);
    axios.post(url)
    .then(res => {
      if (res.data.rowsAffected[0]==1)
      { 
        if(url == open){
          alert("เปิดคิวแล้ว Queue Open!");
        }
        else if (url == close){
          alert("ปิดคิวแล้ว !!! Close Queue");
        }
      }
      else {
        alert("ไม่สำเร็จ กรุณาลองใหม่");
      }
    }).catch(err => { throw err })

    this.LoadQueSetup();
  }

  qfree =0;
  SwithQfree(id:any){
    this.qfree = this.qfree + parseInt(id);
    let open  = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/update_Setup?qfree='Y'"; // เปิด
    let close = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/update_Setup?qfree='N'"; // ปิด
    let url='';
    if (id  == 0){
      url = close;
    }
    else if (id  == 1){
      url = open;
    }
    console.log(url);
    axios.post(url)
    .then(res => {
      if (res.data.rowsAffected[0]==1)
      { 
        if(url == open){
          alert("เปิดการใช้คิวเสรีแล้ว Open!");
        }
        else if (url == close){
          alert("ปิดการใช้คิวเสรีแล้ว  Queue");
        }
      }
      else {
        alert("ไม่สำเร็จ กรุณาลองใหม่");
      }
    }).catch(err => { throw err })

    this.LoadQueSetup();
  }

}
